import { GlobalStyles, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { getYear } from 'date-fns'
import type { ReactNode } from 'react'
import { Link } from 'settle-ui/components/Link/Link'
import { ERouterPage } from 'lib/navigation/consts'
import { useWelcomeVerifiedUser } from 'lib/hooks/useWelcomeVerifiedUser/useWelcomeVerifiedUser'
import { sessionStorageKeys } from 'lib/consts/browserStorage'
import { marketingLinks } from 'lib/consts/externalLinks'
import { getSSItem } from 'lib/helpers/getSSItem/getSSItem'
import { ScheduleDemoLink } from './components/ScheduleDemoLink/ScheduleDemoLink'
import * as $ from './OnboardingLayout.styled'
import { OnboardingTopSection } from './components/OnboardingTopSection/OnboardingTopSection'
import { BusinessTypeEnum } from 'gql/types'

const GLOBAL_STYLES = (
  <GlobalStyles
    styles={{
      html: {
        minHeight: '100vh',
        display: 'flex',
      },
      'body, #__next': {
        flex: 1,
        width: '100%',
        display: 'flex',
      },
    }}
  />
)

export interface IOnboardingLayoutProps {
  hasProgressBar?: boolean
  demoUrl?: string | null
  slots?: {
    secondary?: ReactNode
  }
  businessType?: BusinessTypeEnum
}

export const OnboardingLayout: Settle.FC<IOnboardingLayoutProps> = ({
  slots,
  demoUrl,
  children,
  hasProgressBar = true,
  businessType = BusinessTypeEnum.PAYER,
  ...props
}) => {
  useWelcomeVerifiedUser()
  const { t } = useTranslation()
  const { secondary } = slots ?? {}
  const isDemoScheduled = Boolean(getSSItem(sessionStorageKeys.isDemoScheduled))
  const renderedDemoLink = isDemoScheduled ? null : demoUrl

  return (
    <>
      {GLOBAL_STYLES}
      <$.Root {...props}>
        <OnboardingTopSection visibility="desktop" businessType={businessType} hasProgressBar={hasProgressBar} />
        <$.Paper>
          {secondary && <$.Secondary>{secondary}</$.Secondary>}
          <$.Main>
            <OnboardingTopSection visibility="mobile" businessType={businessType} hasProgressBar={hasProgressBar} />
            {children}
          </$.Main>
        </$.Paper>
        <$.Footer>
          <Typography color="inherit" variant="body2">
            Settle © {getYear(new Date())}
          </Typography>
          <Link href={ERouterPage.termsOfService} color="inherit" variant="body2">
            {t('termsOfService')}
          </Link>
          <Link href={marketingLinks.privacyPolicy} color="inherit" variant="body2">
            {t('privacy')}
          </Link>
        </$.Footer>
        {renderedDemoLink && <ScheduleDemoLink url={renderedDemoLink} />}
      </$.Root>
    </>
  )
}
